import {Component, ElementRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AlertComponent } from 'app/popup/alert.component';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { CountryService } from 'app/services/country.service';
import { PlaceService } from 'app/services/place.service';
import { GooglePlacesSearchService } from 'app/services/google-places-search.service';
import {AgmMap, Geocoder, MapsAPILoader} from '@agm/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { RouteService } from 'app/services/route.service';

@Component({
  selector: 'app-add-new-place',
  templateUrl: './add-new-place.component.html',
  styleUrls: ['./add-new-place.component.css']
})
export class AddNewPlaceComponent implements OnInit {
  form: FormGroup;
  pStatus: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;
  isCodeDup = false;
  isIdDup = false;
  selectedDisplay = 3;
  selectedSUI = 3;
  message = null;
  public isLoading = false;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  countryList: any = [];
  provinceList: any = [];
  placeList: any = [];
  selectedList: any;
  placeId: any = "";
  editFlag: boolean = false;
  lat = -26.195246;
  lng = 28.034088;
  locationChosen = false;
  fromRouteAdmin = false;
  IsNewPlace: boolean = false;
  address: string;
  private geoCoder;

  @ViewChild('search')
  public searchElementRef: ElementRef;  
  @Input() place:any;

  constructor(private statusService: StatusService, private authWebService: AuthWebService,  private mapsAPILoader: MapsAPILoader,
    private router: Router, private ngZone: NgZone,private routeService: RouteService,
    private route: ActivatedRoute, private countryService: CountryService,private toastService:ToastNotificationService,
    private carrierTypeService: CarrierTypeService, private formBuilder: FormBuilder,
     public utility: UtilityServiceService, private toastr: ToastrService,
    private placeService: PlaceService) {
    this.form = this.formBuilder.group({
      code: [''],
      name: [''],
      country_id: [''],
      border_country1_id: ['0'],
      border_country2_id: ['0'],
      province_id: [''],
      parent_place_id: [''],
      longitude: [''],
      latitude: [''],
      place_name: [''],
      coordinates: [''],
      is_town: [false],
      is_border_post: [false],
      is_taxi_rank: [false],
      is_terminus: [false],
      type: [''],
      sort_order: [''],
      group_code: [''],
      display_ind: [''],
      is_active: [true],
      date_created: [new Date()],
      date_modified: [new Date()]

    });
  }


  ngOnInit() {  
    //Call the service and subscribe to the observable.
    //When it received the value then it excutes the method to load the place to be edited.
    this.routeService.getplaceObservable().subscribe(id => {
      let placeId: any = id;
      if(placeId !=0){
        this.getCountries();
        //this.getPlaces(id);
        this.getProvinces();
        this.getSelectedPlace(placeId);
        this.editFlag = true;
        this.locationChosen = true;
        this.fromRouteAdmin=true;
        this.loadAutoComplete();        
      }     
    });
    
    this.isEdit = false;
    this.lblHeading = 'New Place';
    this.btnActionLabel = 'Save';
    let id: any = this.route.params['_value'].id;
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    id = atob(id);
    this.getCountries();
    this.getPlaces(id);
    this.getProvinces();
    this.placeId = btoa(id);
    this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName);
    if (this.router.url.includes('edit')) {
      let placeId: any = this.route.params['_value'].placeId;
      placeId = atob(placeId);
      //this.placeId=placeId;
      this.getSelectedPlace(placeId);
      this.editFlag = true;
      this.locationChosen = true;
    }
    // this.setCurrentLocation();
    this.loadAutoComplete();

  }
  onChoosePlace(event){
   this.lat = event.coords.lat;
   this.lng = event.coords.lng;
   this.form.get('longitude').setValue(this.lng);
   this.form.get('latitude').setValue(this.lat);
   this.locationChosen = true;
   this.placeService.getGeoCode(this.lat + ","+this.lng).subscribe((data:any)=>{
    var address = data;
    var countryId = this.countryList.find( x=> x.desc == address.results[0].address_components.find((item) => item.types.includes('country')).long_name).id;
    this.form.get('country_id').setValue(countryId);
    this.form.get('province_id').setValue(this.provinceList.find( x=> x.description == address.results[0].address_components.find((item) => item.types.includes('administrative_area_level_1')).long_name).id);
    var townName =address.results[0].address_components.find((item) => item.types.includes('locality')).long_name;
    var place = this.placeList.find( x=> x.name == townName);
    if(place == undefined || place == null){
     this.IsNewPlace = true;
     this.form.get('place_name').setValue(townName);
    }else{
      this.IsNewPlace = false;
      this.form.get('parent_place_id').setValue(place.id);
      this.form.get('is_town').setValue(place.is_town);
      this.form.get('name').setValue(place.name);
      this.form.get('type').setValue(place.type);
      this.form.get('is_border_post').setValue(place.is_border_post);
      this.form.get('is_terminus').setValue(place.is_terminus);
      this.form.get('is_taxi_rank').setValue(place.is_taxi_rank);
      this.form.get('is_active').setValue(place.is_active);
      this.form.get('sort_order').setValue(place.sort_order);
      this.form.get('group_code').setValue(place.group_code);
      this.form.get('code').setValue(place.code);
      this.form.get('border_country1_id').setValue(place.border_country1_id == null ? 0 : place.border_country1_id);
      this.form.get('border_country2_id').setValue(place.border_country2_id == null ? 0 : place.border_country2_id);
      this.form.get('coordinates').setValue(place.coordinates);
      this.form.get('display_ind').setValue(place.display_ind);
    }
    

    
    console.log(address);
   }, error => {
    console.log(error);
   });
  }

  setCoordinates(){
    this.form.get('longitude').setValue(this.lng);
    this.form.get('latitude').setValue(this.lat);
    this.locationChosen = true;
    this.placeService.getGeoCode(this.lat + ","+this.lng).subscribe((data:any)=>{
      var address = data;
      var countryId = this.countryList.find( x=> x.desc == address.results[0].address_components.find((item) => item.types.includes('country')).long_name)?.id;
      this.form.get('country_id').setValue(countryId);
      this.form.get('province_id').setValue(this.provinceList.find( x=> x.description == address.results[0].address_components.find((item) => item.types.includes('administrative_area_level_1')).long_name).id);
      var townName =address.results[0].address_components.find((item) => item.types.includes('locality')).long_name;
      var place = this.placeList.find( x=> x.name == townName);
      if(place == undefined || place == null){
        this.IsNewPlace = true;
        this.form.get('place_name').setValue(townName);
      }else{
        this.IsNewPlace = false;
        this.form.get('parent_place_id').setValue(place.id);
        this.form.get('is_town').setValue(place.is_town);
        this.form.get('name').setValue(place.name);
        this.form.get('type').setValue(place.type);
        this.form.get('is_border_post').setValue(place.is_border_post);
        this.form.get('is_terminus').setValue(place.is_terminus);
        this.form.get('is_taxi_rank').setValue(place.is_taxi_rank);
        this.form.get('is_active').setValue(place.is_active);
        this.form.get('sort_order').setValue(place.sort_order);
        this.form.get('group_code').setValue(place.group_code);
        this.form.get('code').setValue(place.code);
        this.form.get('border_country1_id').setValue(place.border_country1_id == null ? 0 : place.border_country1_id);
        this.form.get('border_country2_id').setValue(place.border_country2_id == null ? 0 : place.border_country2_id);
        this.form.get('coordinates').setValue(place.coordinates);
        this.form.get('display_ind').setValue(place.display_ind);
      }



      console.log(address);
    }, error => {
      console.log(error);
    });
  }
  getCountries() {
    this.countryService.listAllCountries().subscribe(res => {
      this.countryList = res;
    })
  }
  getProvinces() {
    this.countryService.listAllProvinces().subscribe(res => {
      this.provinceList = res;
    })
  }
  getPlaces(id) {
    this.placeService.getAllCountryPlaces(id).subscribe(res => {
      this.placeList = res;
    })
  }
  savePlace() {
    let body: any = this.form.value;
    if (!body.is_border_post) {
      body.border_country1_id = null;
      body.border_country2_id = null;
    }
    if (this.editFlag) {
      body.id = this.selectedList.id;
      this.placeService.updatePlace(body).subscribe(res => {
        this.toastService.success('Place updated successfully','success');
        if(!this.fromRouteAdmin){
          this.router.navigate(['/countries/list/' + this.placeId]);
        }else{
          //close the modal
          document.getElementById('closeEditPlaceModal').click(); 
        }
       
      })
    } else {
      body.sort_order=1;
      body.group_code = "A";
      body.display_ind = 3;
      this.placeService.savePlace(body).subscribe(res => {
        this.toastService.success('New Place added successfully','success');
        this.router.navigate(['/countries/list/' + this.placeId]);
      })
    }

  }
  getSelectedPlace(id) {
    this.placeService.getPlaceById(id).subscribe(res => {
      this.selectedList = res;
      this.mergeData(res);
      this.lblHeading = 'Edit: ' + this.selectedList.name;
    })
  }
  borderPostChange(isBorderCrossingRef) {
    let form = this.form.value;
    form.border_country1_id = null;
    form.border_country2_id = null;
    form.is_border_post = isBorderCrossingRef.checked;
    this.mergeData(form);
  }
  mergeData(list) {
    this.form.get('code').setValue(list.code);
    this.form.get('country_id').setValue(list.country_id);
    this.form.get('border_country1_id').setValue(list.border_country1_id == null ? 0 : list.border_country1_id);
    this.form.get('border_country2_id').setValue(list.border_country2_id == null ? 0 : list.border_country2_id);
    this.form.get('name').setValue(list.name);
    this.form.get('province_id').setValue(list.province_id);
    this.form.get('type').setValue(list.type);
    this.form.get('parent_place_id').setValue(list.parent_place_id);
    this.form.get('longitude').setValue(list.longitude);
    this.form.get('latitude').setValue(list.latitude);
    this.form.get('coordinates').setValue(list.coordinates);
    this.form.get('is_town').setValue(list.is_town);
    this.form.get('is_border_post').setValue(list.is_border_post);
    this.form.get('is_terminus').setValue(list.is_terminus);
    this.form.get('is_taxi_rank').setValue(list.is_taxi_rank);
    this.form.get('is_active').setValue(list.is_active);
    this.form.get('sort_order').setValue(list.sort_order);
    this.form.get('group_code').setValue(list.group_code);
    this.form.get('display_ind').setValue(list.display_ind);
    this.form.get('date_created').setValue(list.date_created);
    this.form.get('date_modified').setValue(list.date_modified);
    this.audit = this.utility.setAuditAttributes(list.date_created, this.user.LastName, list.date_modified, this.user.LastName);
    this.lat = list.latitude;
    this.lng = list.longitude;
  }

  clearForm(){
    this.form.reset();
    this.ngOnInit();
    this.locationChosen = false;
  }
  zoom = null;
  loadAutoComplete(){
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
         this.zoom = 12;
          this.setCoordinates();
        });
      });
    });
  }
  @ViewChild('myMap', {static: false}) myMap: AgmMap;
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }

markerDragEnd($event: any) {
  console.log($event);
  this.lat = $event.coords.lat;
  this.lng = $event.coords.lng;
  this.getAddress(this.lat, this.lng);
}

getAddress(latitude, longitude) {
  this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
    console.log(results);
    console.log(status);
    if (status === 'OK') {
      if (results[0]) {
        //set zoom here
        this.address = results[0].formatted_address;
      } else {
        window.alert('No results found');
      }
    } else {
      window.alert('Geocoder failed due to: ' + status);
    }

  });
}


}
